const isDevelopment = process.env.NODE_ENV === 'development';

const config = {
    baseUrl: isDevelopment ? '' : process.env.VUE_APP_API_HOST_AWS,
    port: isDevelopment ? '' : ':8443',
    context: '/services/happinesslucas/core/happiness-tips'
};

export default config;